module.exports = __webpack_public_path__ + "img/6.81ebba4f.png";